import { AxiosError } from "axios";
import { handleAxiosError, ErrorResponse } from "../../errors/errorHandler";

/**
 * createETaxBatch and createETaxNoteBatch opt out of the interceptor's error toast so a gate
 * refusal can become a dialog instead; every other failure is raised here exactly as the
 * interceptor would have. A 403 has already swapped in the permission page, and a cancelled
 * request (SSO ended, redirecting to login) has nothing worth saying.
 */
export const reportSendError = (error: unknown) => {
  const axiosError = error as AxiosError<ErrorResponse>;
  if (!axiosError?.isAxiosError) return;
  if (
    axiosError.response?.status === 403 &&
    !axiosError.config?.meta?.suppressForbiddenRedirect
  ) {
    return;
  }
  handleAxiosError(axiosError);
};
